import { apiGet, apiSend } from './httpClient'
import type {
  MarketplaceCategory,
  MarketplaceRecommendation,
  MarketplaceSearchResult,
  Trip,
} from './types'

export function searchMarketplace(
  tripId: string,
  category: MarketplaceCategory,
  params?: { origin?: string; destination?: string; depart_date?: string; return_date?: string },
): Promise<MarketplaceSearchResult> {
  const q = new URLSearchParams({ category })
  if (params?.origin) q.set('origin', params.origin)
  if (params?.destination) q.set('destination', params.destination)
  if (params?.depart_date) q.set('depart_date', params.depart_date)
  if (params?.return_date) q.set('return_date', params.return_date)
  return apiGet<MarketplaceSearchResult>(`/trips/${tripId}/marketplace/search?${q}`)
}

export function compareMarketplace(
  tripId: string,
  category: MarketplaceCategory,
): Promise<MarketplaceSearchResult> {
  return apiGet<MarketplaceSearchResult>(`/trips/${tripId}/marketplace/compare?category=${category}`)
}

export function getMarketplaceRecommendations(tripId: string): Promise<MarketplaceRecommendation[]> {
  return apiGet<MarketplaceRecommendation[]>(`/trips/${tripId}/marketplace/recommendations`)
}

export function saveMarketplaceOffer(
  tripId: string,
  offer: {
    title: string
    url: string
    affiliate_url?: string
    provider: string
    price?: number
    currency?: string
    check_in?: string
    check_out?: string
  },
): Promise<{ id: string }> {
  return apiSend<{ id: string }>('POST', `/trips/${tripId}/marketplace/save`, {
    title: offer.title,
    url: offer.url,
    affiliate_url: offer.affiliate_url,
    provider: offer.provider,
    price: offer.price,
    currency: offer.currency,
    check_in: offer.check_in,
    check_out: offer.check_out,
  })
}

export function createTripFromTemplate(input: {
  template: 'cruise' | 'road_trip'
  title?: string
  destination?: string
  start_date?: string
  end_date?: string
}): Promise<Trip> {
  return apiSend<Trip>('POST', '/trips/from-template', input)
}
